
routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
helloController.$inject = ["$scope", "$http"];angular
  .module('app', ['ui.router', 'ui.bootstrap']);

angular
  .module('app')
  .directive('newsItem', function () {
    return {
      restrict: 'E',
      scope: {
        itemData: '=data'
      },
      controller: ['$scope', '$sce', newsItemController],
      templateUrl: 'app/newsitem/newsitem.html'
    };
  }
);

function newsItemController($scope, $sce) {
  $scope.innerHTML = $sce.trustAsHtml($scope.itemData.rawhtml);
  $scope.imagelist = $scope.itemData.images;
}

angular
  .module('app')
  .component('app', {
    templateUrl: 'app/hello.html',
    controller: helloController
  });

function helloController($scope, $http) {
  $scope.tags = [];
  $http
    .get("data/taglist.json")
    .then(function (result) {
      $scope.tags = result.data;
    });
  $scope.limitExpand = 10;
  $scope.limit = $scope.limitExpand;
  var news = [];
  $http
    .get("data/news.json")
    .then(function (result) {
      news = result.data;
      $scope.selectedNews = performSeach('', news);
    });
  $scope.$watch('searchText', function (search) {
    $scope.selectedNews = performSeach(search, news);
  });
}

function performSeach(search, news) {
  var searchArray = [];
  if (search) {
    searchArray = search.split(',').map(function (s) {
      return s.trim().toLowerCase();
    });
  }
  for (var i = 0; i < news.length; i++) {
    news[i].relevance = computeRelevance(searchArray, news[i]);
  }
  // only news item with non 0 relevance
  var selected = news.filter(function (element) {
    return element.relevance > 0;
  });
  // sort by relevance and time
  selected = selected.sort(function (a, b) {
    var comp = b.relevance - a.relevance;
    if (comp === 0) {
      if (a.date > b.date) {
        comp = -1;
      } else if (a.date < b.date) {
        comp = 1;
      }
    }
    return comp;
  });
  return selected;
}

function computeRelevance(searchArray, newsitem) {
  var tags = newsitem.tags || [];
  var relevance = 1;
  if (searchArray) {
    searchArray.forEach(function (searchWord) {
      var partialRelevance = 0;
      tags.forEach(function (item) {
        if (item.tag === searchWord) {
          partialRelevance += item.importance;
        }
      });
      relevance *= partialRelevance;
    });
  }
  return relevance.toFixed(2);
}

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/hello.html","<div class=\"container-fluid\">\n    <div class=\"col-md-3\"></div>\n    <div class=\"col-md-6\">\n      <div class=\"row\">\n        <div class=\"page-header\">\n        <h1>Newsletter technique de Quantmetry<br><small>I\'m reading blog posts so you don\'t have to</small></h1>\n        <div class=\"input-group input-group-lg\">\n          <span class=\"input-group-addon\" id=\"sizing-addon1\">Recherche</span>\n          <input type=\"text\" class=\"form-control\" placeholder=\"comma-separated words\" aria-describedby=\"sizing-addon1\" ng-model=\"searchText\" uib-typeahead=\"tag for tag in tags  | filter:$viewValue | limitTo:10\" typeahead-editable=\"true\">\n        </div>\n      </div>\n      </div>\n\n        <div class=\"row\">\n          <div ng-repeat=\"item in selectedNews | limitTo: limit as results\">\n            <news-item data=\"item\"></news-item>\n          </div>\n        </div>\n        <div class=\"row\">\n          <button type=\"button\" class=\"btn btn-primary btn-block\" ng-hide=\"results.length === selectedNews.length\" ng-click=\"limit = limit + limitExpand\">\n                Show {{limitExpand}} More ({{selectedNews.length - results.length}} remaining)\n          </button>\n        </div>\n    </div>\n    <div class=\"col-md-3\"></div>\n</div>\n\n<div class=\"footer\">\n  <p>Copyright (c) 2017</p>\n</div>\n");
$templateCache.put("app/newsitem/newsitem.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <h3 class=\"panel-title\">{{itemData.title}}</h3>\n    <p> <em>{{itemData.date}}</em>   (score: {{itemData.relevance}}) </p>\n  </div>\n  <div class=\"panel-body\" ng-bind-html=\"innerHTML\">\n    <!-- {{itemData.rawhtml}} -->\n  </div>\n  <!-- <div class=\"panel-footer\"> -->\n    <img src=\"data/images/{{imagename}}\" ng-repeat=\"imagename in imagelist\" class=\"img-responsive\">\n  <!-- </div> -->\n</div>\n");}]);
angular
  .module('app')
  .config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true).hashPrefix('!');
  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('app', {
      url: '/',
      component: 'app'
    });
}
